<script>
  export let reviewer;
  export let articleVersion;
  export let onRemove;
  export let last;

  import { dictionary } from "../utils/stores.js";

  import { onMount } from "svelte";

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  let fechaRespuesta = "";
  let respuestaIcon = "";
  let respuestaTitle = "";
  let estadoRevision = "";
  let estadoRevisionText = "-";
  let estadoColor = "var(--revista-black)";
  let fechadecisionRevisor = "";

  onMount(() => {
    fechaRespuesta =
      reviewer.aceptado === ""
        ? "-"
        : moment(reviewer.fechaAceptado).format("DD MMMM YYYY HH:mm:ss");
    switch (reviewer.aceptado) {
      case "Si":
        respuestaIcon = "/images/revista/revisor-accept.svg";
        respuestaTitle = dict["decisionRevisorOk"];
        break;
      case "No":
        respuestaIcon = "/images/revista/revisor-reject.svg";
        respuestaTitle = dict["decisionRevisorNoOk"];
        break;
      default:
        respuestaIcon = "/images/revista/clock.svg";
        respuestaTitle = dict["decisionRevisor"];
        break;
    }

    if (articleVersion === 2 && reviewer.decisionDocumento2.decision !== "") {
      estadoRevision = reviewer.decisionDocumento2.decision;
      fechadecisionRevisor = moment(
        reviewer.decisionDocumento2.fechaRevision
      ).format("DD MMMM YYYY HH:mm:ss");
    } else {
      if (reviewer.decisionDocumento1.decision !== "") {
        estadoRevision = reviewer.decisionDocumento1.decision;
        fechadecisionRevisor = moment(
          reviewer.decisionDocumento1.fechaRevision
        ).format("DD MMMM YYYY HH:mm:ss");
      }
    }
    switch (estadoRevision) {
      case "Aceptado":
        estadoRevisionText = "- " + dict["aceptadoParaPublicacion"];
        estadoColor = "var(--revista-green)";
        break;
      case "CambiosMenores":
        estadoRevisionText = "- " + dict["aceptadoConCambiosMenores"];
        estadoColor = "var(--revista-orange)";
        break;
      case "CambiosMayores":
        estadoRevisionText = "- " + dict["aceptadoConCambiosMayores"];
        estadoColor = "var(--revista-orange-red)";
        break;
      case "Rechazado":
        estadoRevisionText = "- " + dict["rechazado"];
        estadoColor = "var(--revista-red)";
        break;
    }
  });
</script>

<style>
  div.articleReviewerItem {
    display: flex;
    width: 100%;
    color: var(--revista-black) !important;
    padding-top: 10px;
    padding-bottom: 10px;
    border-top-color: lightgray;
    border-top-width: 1px;
    border-top-style: solid;
    justify-content: space-between;
    align-items: center;
  }

  div.last {
    border-bottom-color: lightgray;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }

  div.icon {
    margin-right: 20px;
  }

  div.icon img {
    width: 25px;
    height: 25px;
  }

  div.info {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  div.infoNombre {
    color: #3375ec;
    font-weight: bold;
  }

  div.options {
    display: flex;
  }

  div.options img {
    width: 20px;
    height: 20px;
    margin-left: 5px;
  }

  img.imgButton {
    cursor: pointer;
  }

  div.decision img {
    width: 20px;
    height: 20px;
  }
</style>

<div class="articleReviewerItem {last ? 'last' : ''}">
  <div class="icon">
    <img class="user" src="/images/revista/eye.svg" alt="User Icon" />
  </div>
  <div class="info">
    <div class="infoNombre">
      {reviewer.nombreUsuario} {reviewer.apellido1Usuario}
      {reviewer.apellido2Usuario}
    </div>
    <div>
      <a href={'mailto:' + reviewer.email}>{reviewer.email}</a>
    </div>
    <div>
      <i>{reviewer.institucionUsuario}</i>
    </div>
    <div>
      <b>{dict['fechaPropuesta']}:</b>
      {moment(reviewer.fechaProposicion).format('DD MMMM YYYY HH:mm:ss')}
    </div>
    <div>
      <b>{dict['fechaRespuesta']}:</b>
      {fechaRespuesta}
    </div>
    {#if reviewer.aceptado === 'No'}
      <div>
        <b>{dict['motivo']}:</b>
        {reviewer.motivoRechazo}
      </div>
      {#each reviewer.sugerenciasRevisores as propuesta, index}
        <div>
          <span>
            <b>Propuesta {index + 1}:</b>
            {propuesta.nombreApellidos} -
            <i>{propuesta.institucion}</i>
            - {propuesta.email}
          </span>
        </div>
      {/each}
    {/if}
    <div class="decision">
      <b>{dict['decision']}:</b>
      {fechadecisionRevisor}
      <span style="color: {estadoColor}">{estadoRevisionText}</span>
      {#if estadoRevision === 'Aceptado'}
        <img
          src="/images/revista/revisor-v-color.svg"
          title={dict['decisionRevisorOk']}
          alt="Revision Icon" />
      {:else if estadoRevision === 'CambiosMenores'}
        <img
          src="/images/revista/revisor-v-minor-color.svg"
          title={dict['decisionRevisorNoOk']}
          alt="Revision Icon" />
      {:else if estadoRevision === 'CambiosMayores'}
        <img
          src="/images/revista/revisor-v-major-color.svg"
          title={dict['decisionRevisorNoOk']}
          alt="Revision Icon" />
      {:else if estadoRevision === 'Rechazado'}
        <img
          src="/images/revista/revisor-x-color.svg"
          title={dict['decisionRevisor']}
          alt="Revision Icon" />
      {/if}
    </div>
  </div>
  <div class="options">
    <img title={respuestaTitle} src={respuestaIcon} alt="Pending Icon" />
    <img
      class="imgButton"
      title={dict['eliminar']}
      src="/images/revista/close.svg"
      alt="Remove Icon"
      on:click={onRemove} />
  </div>
</div>
